/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Automatic/ResourceGroupSecondaryTextComponent" />

import * as React from "react";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";

export class ResourceGroupSecondaryTextComponent extends VssComponent {

    public render(): React.ReactNode {
        return !this.props.disableComponent ? (
            <div className="secondary-text fontSizeS">{Resources.ResourceGroupSecondaryText}</div>
        ) : null;
    }
}
